// Utility function to truncate long strings with ellipsis
export const truncateString = (
  str: string,
  maxLength: number = 30,
  startChars: number = 8,
  endChars: number = 6,
): string => {
  if (str.length <= maxLength) {
    return str;
  }

  const start = str.slice(0, startChars);
  const end = str.slice(-endChars);
  return `${start}***${end}`;
};
